import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  emptyList1g2z5xcrvp2zy as emptyList,
  getKClass1s3j9wy1cofik as getKClass,
  Unit_instance104q5opgivhr8 as Unit_instance,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_getInstance1rlvzabi952im as Companion_getInstance,
  Kind_Factory_getInstance2ge7vb99ubfwr as Kind_Factory_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  FactoryInstanceFactory2tq2q9e5id3pz as FactoryInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
import { Clientssjxb7gh2u6y as Client } from './Shared7Punches-infrastructure-network.mjs';
import { ILogger102gekz4uf4a8 as ILogger } from './Shared7Punches-infrastructure-logging.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForInterface(IPayrollRepository, 'IPayrollRepository', VOID, VOID, VOID, [6, 2, 5, 1]);
initMetadataForClass(PayrollRepository, 'PayrollRepository', VOID, VOID, [IPayrollRepository], [6, 2, 5, 1]);
initMetadataForInterface(IPayrollRemoteSource, 'IPayrollRemoteSource', VOID, VOID, VOID, [6, 2, 5, 1]);
initMetadataForClass(PayrollRemoteSource, 'PayrollRemoteSource', VOID, VOID, [IPayrollRemoteSource], [6, 2, 5, 1]);
//endregion
function PayrollRepository(remoteSource, logger) {
  this.u8z_1 = remoteSource;
  this.v8z_1 = logger;
}
function IPayrollRemoteSource() {
}
function PayrollRemoteSource(apiClient) {
  this.w8z_1 = apiClient;
}
function get_payrollModule() {
  _init_properties_PayrollModule_kt__txo0sf();
  return payrollModule;
}
var payrollModule;
function payrollModule$lambda($this$module) {
  _init_properties_PayrollModule_kt__txo0sf();
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = payrollModule$lambda$lambda;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Factory_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(IPayrollRemoteSource), null, tmp2, kind, secondaryTypes);
  var factory = new FactoryInstanceFactory(def);
  $this$module.p1c(factory);
  new KoinDefinition($this$module, factory);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_0 = payrollModule$lambda$lambda_0;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_0 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_0 = Kind_Factory_getInstance();
  var secondaryTypes_0 = emptyList();
  var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(IPayrollRepository), null, tmp2_0, kind_0, secondaryTypes_0);
  var factory_0 = new FactoryInstanceFactory(def_0);
  $this$module.p1c(factory_0);
  new KoinDefinition($this$module, factory_0);
  return Unit_instance;
}
function payrollModule$lambda$lambda($this$factory, it) {
  _init_properties_PayrollModule_kt__txo0sf();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$factory.q1d(getKClass(Client), null, null);
  return new PayrollRemoteSource(tmp$ret$0);
}
function payrollModule$lambda$lambda_0($this$factory, it) {
  _init_properties_PayrollModule_kt__txo0sf();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(IPayrollRemoteSource), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ILogger), null, null);
  return new PayrollRepository(tmp, tmp$ret$1);
}
var properties_initialized_PayrollModule_kt_jw75j5;
function _init_properties_PayrollModule_kt__txo0sf() {
  if (!properties_initialized_PayrollModule_kt_jw75j5) {
    properties_initialized_PayrollModule_kt_jw75j5 = true;
    payrollModule = module_0(VOID, payrollModule$lambda);
  }
}
function IPayrollRepository() {
}
//region block: exports
export {
  get_payrollModule as get_payrollModule1batjuxuwzt4i,
  IPayrollRepository as IPayrollRepository3r3v326s8y6w0,
};
//endregion

